import { render, staticRenderFns } from "./home.vue?vue&type=template&id=6576b2a7&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\vue_project\\odoo14_chaxin_qzkj_vue\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports